import { useState, useEffect } from 'react';
import { apiService } from '../services/api';

export function useLeads() {
  const [leads, setLeads] = useState(() => apiService.getLeads());

  useEffect(() => {
    // Keep state in sync with localStorage updates
    const handleStorageChange = () => {
      setLeads(apiService.getLeads());
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const refreshLeads = () => {
    setLeads(apiService.getLeads());
  };

  const updateLead = (id, updatedFields) => {
    const updated = apiService.updateLead(id, updatedFields);
    setLeads(updated);
  };

  const updateStatus = (id, newStatus) => {
    const updated = apiService.updateLeadStatus(id, newStatus);
    setLeads(updated);
  };

  const updateAssignee = (id, newAssignee) => {
    const updated = apiService.updateLeadAssignee(id, newAssignee);
    setLeads(updated);
  };

  const addNote = (id, noteText, author) => {
    const updated = apiService.addLeadNote(id, noteText, author);
    setLeads(updated);
  };

  const createLead = (leadData) => {
    const newLead = apiService.createLead(leadData);
    refreshLeads();
    return newLead;
  };

  const deleteLead = (id) => {
    const updated = apiService.deleteLead(id);
    setLeads(updated);
  };

  const resetData = () => {
    apiService.resetDemoData();
    refreshLeads();
  };

  return {
    leads,
    refreshLeads,
    updateLead,
    updateStatus,
    updateAssignee,
    addNote,
    createLead,
    deleteLead,
    resetData
  };
}
